module.exports = __webpack_public_path__ + "static/media/zfb.d53fe000.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zfb.png
// module id = 2014
// module chunks = 2